var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Scrollable", { style: _vm.scrollableStyle }, [
    _c(
      "div",
      {
        staticClass: "betslip-body-wrapper",
        class: { active: _vm.activeBetslip },
        style: {
          "background-image": !_vm.activeBetslip
            ? "url(" +
              require("../../assets/empty-betslip-" + _vm.theme + ".png") +
              ")"
            : "none",
        },
      },
      [
        _c("span", { staticClass: "empty-message" }, [
          _vm._v(
            " " + _vm._s(_vm._f("translate")(_vm.emptyBetslipMessage)) + " "
          ),
        ]),
        _c("BetslipBet", { attrs: { bettingLocked: _vm.bettingLocked } }),
        _c("BetslipFooter", {
          attrs: {
            bettingLocked: _vm.bettingLocked,
            payinDisabled: _vm.payinDisabled,
            predefinedStakes: _vm.predefinedStakes,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }